module.exports = __webpack_public_path__ + "img/kefu.372cb1f7.jpg";